import { LogLevel, PublicClientApplication } from '@azure/msal-browser';
export const msalConfig = {
  auth: {
//TODO:  move this back to the original structure so we can deploy to dev/prod without hardcoding
    clientId: process.env.REACT_APP_CLIENT_ID, 
    authority: process.env.REACT_APP_AUTHORITY,
    // clientId: `8b2bdf0d-d3f2-4737-b4fd-7c256ad4b8cf`,
    // authority: `https://login.microsoftonline.com/2fc13e34-f03f-498b-982a-7cb446e25bc6`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true,
  },
  system: {
    allowNativeBroker: false, // Disables WAM Broker
    loggerOptions: {
      loggerCallback: (
        level,
        message,
        containsPii
      ) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            return
          case LogLevel.Info:
            console.info(message)
            return
          case LogLevel.Verbose:
            console.debug(message)
            return
          case LogLevel.Warning:
            console.warn(message)
            break
          default:
        }
      },
    },
  },
}

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
  scopes: ['User.Read'],
  };

const msalInstance = new PublicClientApplication(msalConfig);
export default msalInstance;


